import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

// A custom theme for this app
const customTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#283891',
      light2: '#e4e6f1',
    },
    secondary: {
      main: '#38B54A',
      light: '#cdecd2',
      contrastText: '#fff',
    },
    info: {
      main: '#283891',
    },
    warn: {
      main: '#F9A01B',
    },
    success: {
      main: '#38B54A',
    },
    background: {
      default: '#fffff',
    },
  },
  typography: {
    fontSize: 12,
    h1: {
      fontSize: '2.25rem',
    },
    h2: {
      fontSize: '2.25rem',
    },
  },
});

const theme = responsiveFontSizes(customTheme);

export default theme;
